import { combineReducers, type Store } from 'redux';
import { agreementReducer } from 'core/agreement/store/reducer';
import { authReducer } from 'core/auth/store/reducer';
import { contentReducer } from 'core/content/store/reducer';
import { featureFlagsReducer } from 'core/feature-flags/store/reducer';
import { funnelConfigReducer } from 'core/funnel/store/reducer';
import { humanDesignReducer } from 'core/human-design/store';
import { natalChartReducer } from 'core/natal-chart/store/reducer';
import { offersReducer } from 'core/offers/store';
import { paymentsReducer } from 'core/payments/store/reducer';
import { popUpsReducer } from 'core/popUp/store';
import { scanReducer } from 'core/scan/store';
import { supportReducer } from 'core/support/store/reducer';
import {
  userInteractionReducer,
  userLocationReducer,
  userProfile,
  userResponsesReducer,
  userSubscriptionsReducer,
  userUtmTagsReducer,
} from 'core/user/store/reducer';
import { systemReducer } from './system';

const rootReducer = combineReducers({
  userProfile,
  userUtmTags: userUtmTagsReducer,
  system: systemReducer,
  popUps: popUpsReducer,
  auth: authReducer,
  agreement: agreementReducer,
  offers: offersReducer,
  payments: paymentsReducer,
  funnelConfig: funnelConfigReducer,
  humanDesign: humanDesignReducer,
  featureFlags: featureFlagsReducer,
  userLocation: userLocationReducer,
  userResponses: userResponsesReducer,
  userSubscriptions: userSubscriptionsReducer,
  userInteraction: userInteractionReducer,
  natalChart: natalChartReducer,
  scan: scanReducer,
  content: contentReducer,
  support: supportReducer,
});

export type RootInitialState = ReturnType<typeof rootReducer>;
export type RootStore = Store<RootInitialState>;

export default rootReducer;
